import { useContext } from 'react';

import { FermentationActionContext } from './provider';

export const useFermentationAction = () => {
  return useContext(FermentationActionContext);
};
